import React, { useRef } from 'react';
import { uploadSVCFile } from '../../API/SVCUploadApi';
import SVCUploadHistory from '../../shared/SVCUploadHistoryTable/SVCUploadHistoryTable';
import AlertManager from "../../shared/Alert/Alert";
import classes from "./SVCUpload.module.css";
import { useUploadHistory } from "../SVCUploadHistory/SVCUploadHistory.hooks";
import { Button, Tooltip, Box } from "@mui/material";
import { downloadTemplateFile } from "../../API/svcDownloadTemplateFileApi";

//import { getSVCUploadHistory } from '../../API/SVCUploadHistoryApi';

const SVCUpload = () => {
    const { uploadHistory, fetchUploadHistory, loading } = useUploadHistory();
    const fileInputRef = useRef();
    //const[uploadHistory ,fetchUploadHistory] = useState([]);   
    const upload = (e) => {
        e.preventDefault();
        const form = new FormData(e.target);

        const file = form.get("file");
        // const costType = form.get("costType");
        const target = e.target;

        // if (!costType || costType === COST_TYPES.none) {
        //     AlertManager.error('Please select the cost type.', { contactSupport: false });
        //     return;
        // }

        if (!file) {
            AlertManager.error('Please select the file that wanted to upload.', { contactSupport: true });
            return;
        }
        if (!file.name.toLocaleLowerCase().endsWith("xlsx") && !file.name.toLocaleLowerCase().endsWith("xls")) {
            AlertManager.error('Please select file with extension .xlsx or .xls', { contactSupport: false });
            return;
        }
        uploadSVCFile(file)
            .then((res) => {

                if(fileInputRef.current){
                    fileInputRef.current.value = "";
                }


                if (res.status === 200 || res.status === 201) {
                    fetchUploadHistory();
                    AlertManager.success("The SVC has been successfully uploaded. User will receive emails on processing updates.", { contactSupport: false });

                    target.reset();
                }
                else {
                    res.json().then(data => {
                        if (res.status === 400) {
                            AlertManager.error(data.error);
                        } else {
                            AlertManager.error('There were some issues while uploading the file.'

                            );
                        }
                    }).catch(() => {
                        AlertManager.error('There were some issues while processing the server response.');
                    });
                }
            })
            .catch((err) => {
                AlertManager.error('Error');
            });
    };

    return (
        <div className={classes.body}>
            <div className={classes.heading}> Upload Secondary Cost ASG</div>
            <form className={classes.container} onSubmit={upload}>
                <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <input
                        className={classes.fileUploadInputFile}
                        name={"file"}
                        type="file"
                        accept={".xlsx, .xls"}
                        ref={fileInputRef}
                    />
                </Box>

                <br />
                <button className={classes.uploadBtn}>upload</button>
                <Tooltip title="Raw template will be downloaded.">
                    <Button className={classes.uploadBtn}
                        onClick={() => downloadTemplateFile()}>
                        Download Template
                    </Button>
                </Tooltip>
            </form>

            <div className={classes.hLine}></div>


            <div className={classes.fileuploadHistory}>
                <SVCUploadHistory uploadHistory={uploadHistory} loading={loading} />
            </div>

        </div>
    );
};

export default SVCUpload;
